import { setIn } from 'immutable';
import * as AT from './actionTypes';



const INITIAL_STATE = {
  chainId: null,
  blockNumber: null,
};


function providerReducer(state = INITIAL_STATE, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case AT.CLEAR: {
      return INITIAL_STATE;
    }

    case AT.SET_CHAIN_ID: {
      return setIn(state, ['chainId'], payload);
    }
    case AT.SET_BLOCK_NUMBER: {
      return setIn(state, ['blockNumber'], payload);
    }

    default:
      return state;
  }
}

export default providerReducer;
